// extracted by mini-css-extract-plugin
export default {"OwnerCellWrapper":"OwnerCellRenderer_OwnerCellWrapper__BFhUu","HistoryTriggerButton":"OwnerCellRenderer_HistoryTriggerButton__gpo7P"};